'use strict' ;

/**
 * A basic <code>trace()</code> function based on the console.log method.
 * @name trace
 * @function
 * @example
 * trace( 'hello world' ) ;
 */
function trace( context )
{
    if( console )
    {
        console.log( context ) ;
    }
}

export default trace ;